import * as React from 'react';
import '../css/section-message.sass';
import MultipleMessagesPopup from './MultipleMessagesPopup';
import StaticElementButton from './StaticElementButton';

export interface SectionMessageType {
  type: 'info' | 'warning' | 'error' | 'success';
  message: React.ReactNode;
}

interface SectionMessageProps {
  messages: SectionMessageType[];
}

interface SectionMessageState {
  displayMessagesPopup: boolean;
}

export default function SectionMessage(props: SectionMessageProps) {
  const [state, setState] = React.useState<SectionMessageState>({
    displayMessagesPopup: false
  });
  const handleMultipleMessage = () => {
    setState({ ...state, displayMessagesPopup: true });
  };

  if (props.messages.length === 0) {
    return <></>;
  }
  return (
    <>
      <div className="sectionMessageContainer" role="alert">
        {props.messages && props.messages.length === 1 && (
          <div className={`sectionMessage ${props.messages[0].type}`}>
            <span className="icon" />
            <div>{props.messages[0].message}</div>
          </div>
        )}
        {props.messages && props.messages.length > 1 && (
          <div className="sectionMessage multiple">
            <span className="icon" />
            <StaticElementButton
              name="smmultimessages"
              id="smmultimessages"
              label="See Multiple Messages"
              type="div"
              onClick={handleMultipleMessage}
            >
              See Multiple Messages
            </StaticElementButton>
          </div>
        )}
      </div>
      {state.displayMessagesPopup && (
        <MultipleMessagesPopup
          messages={props.messages}
          onClose={() => setState({ ...state, displayMessagesPopup: false })}
        />
      )}
    </>
  );
}
